import { defineMessages } from "react-intl"

export default defineMessages({
  noVehiclesFound: {
    defaultMessage: "No Vehicles Found",
    id: "src.components.VehicleCarousel.noVehiclesFound",
  },
})
